// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PrivacyView_Wrapper__2J6fJ","Image":"PrivacyView_Image__1Jg84","Text":"PrivacyView_Text__XvhW3","List":"PrivacyView_List__M2p4g"};